export default {
  // 获取赛程信息
  querySeasonRaceSchedule: async function (that, formData) {
    const { data: res } = await that.$http.get('/raceSchedule/querySeasonRaceSchedule', {
      params: formData
    })
    return res
  }
}
